/**
 * Cover images for homepage “Straipsniai ir gidai” cards.
 * s1 — būklė, s2 — IMEI, s3 — siuntimas, s4 — baterija, s5 — No Rock, s6 — pasiūlymai.
 */

const STORY_ORIGIN = 'https://redevicer.com'

const STORY_COVER: Record<string, string> = {
  s1: '/story-covers/s1.png',
  s2: '/story-covers/s2.png',
  s3: '/story-covers/s3.png',
  s4: '/story-covers/s4.png',
  s5: '/story-covers/s5.png',
  s6: '/story-covers/s6.png',
}

function inBrowser(): boolean {
  return typeof globalThis !== 'undefined' && 'document' in globalThis
}

export function getStoryCoverUrl(storyKey: string, _width: number = 720): string {
  const path = STORY_COVER[storyKey] ?? STORY_COVER.s1
  if (path.startsWith('http')) return path
  if (inBrowser()) return path
  return `${STORY_ORIGIN}${path}`
}
